import { collection, doc, getDocs, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "../firebase";

const normalizeTournamentKey = (value = "") =>
  String(value)
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

async function resolveTournamentDoc({ tournamentId, tournamentName }) {
  const targetTournamentId = String(tournamentId || "").trim();
  const targetTournamentName = String(tournamentName || "").trim();
  const targetTournamentIdKey = normalizeTournamentKey(targetTournamentId);
  const targetTournamentNameKey = normalizeTournamentKey(targetTournamentName);

  if (!targetTournamentId && !targetTournamentName) {
    return null;
  }

  const tournamentsSnap = await getDocs(collection(db, "tournaments"));
  let matched = null;

  tournamentsSnap.docs.forEach((item) => {
    if (matched) return;
    const data = item.data() || {};
    const idKey = String(item.id || "").trim().toLowerCase();
    const nameKey = String(data.name || "").trim().toLowerCase();
    const slugKey = normalizeTournamentKey(data.tournamentId || data.slug || data.name || item.id || "");

    if (
      (targetTournamentId && idKey === targetTournamentId.toLowerCase()) ||
      (targetTournamentName && nameKey === targetTournamentName.toLowerCase()) ||
      (targetTournamentIdKey && slugKey === targetTournamentIdKey) ||
      (targetTournamentNameKey && slugKey === targetTournamentNameKey)
    ) {
      matched = {
        docId: item.id,
        data,
      };
    }
  });

  return matched;
}

export async function sendDirectorCertifiedVideoEvent({
  certId,
  tournamentId,
  tournamentName,
  teamId,
  teamName,
  userId,
  catchData,
  downloadUrl = "",
  source = "app-upload",
}) {
  if (!certId || !userId) {
    throw new Error("Missing certId or userId for certified video event");
  }

  const resolvedTournament = await resolveTournamentDoc({ tournamentId, tournamentName });
  if (!resolvedTournament?.docId) {
    return null;
  }

  const tournamentData = resolvedTournament.data || {};
  const resolvedTournamentName = String(tournamentData.name || tournamentName || "").trim();
  const resolvedDirectorId = String(tournamentData.directorId || tournamentData.createdByUid || "").trim();
  const resolvedTeamName = String(teamName || "").trim();
  const eventId = `certified-video-${certId}`;

  await setDoc(
    doc(db, "tournaments", resolvedTournament.docId, "events", eventId),
    {
      type: "certified_video_uploaded",
      title: "Certified Video Uploaded",
      message: `${resolvedTeamName || "A team"} uploaded a certified video for ${resolvedTournamentName || "this tournament"}.`,
      status: "pending",
      targetRole: "director",
      ...(resolvedDirectorId ? { targetUserId: resolvedDirectorId } : {}),
      tournamentId: resolvedTournament.docId,
      tournamentName: resolvedTournamentName,
      teamId: String(teamId || "").trim(),
      teamName: resolvedTeamName,
      userId: String(userId || "").trim(),
      certId: String(certId || "").trim(),
      source,
      metadata: {
        tournamentId: resolvedTournament.docId,
        tournamentName: resolvedTournamentName,
        teamId: String(teamId || "").trim(),
        teamName: resolvedTeamName,
        userId: String(userId || "").trim(),
        certId: String(certId || "").trim(),
        species: String(catchData?.species || "").trim(),
        size: String(catchData?.size || "").trim(),
        weight: String(catchData?.weight || "").trim(),
        weightLbs:
          typeof catchData?.weightLbs === "number"
            ? catchData.weightLbs
            : (Number(catchData?.weightLbs) || null),
        lengthIn:
          typeof catchData?.lengthIn === "number"
            ? catchData.lengthIn
            : (Number(catchData?.lengthIn) || null),
        downloadUrl: String(downloadUrl || "").trim(),
      },
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );

  return eventId;
}